import React from 'react'
import CloseButton from 'react-bootstrap/CloseButton'
import Text from './Text'
import Image from './Image'
import Audio from './Audio'
import Video from './Video'

interface IProps {
  intent: any
  closeModal: () => void
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const CustomisationInstaModal: React.FC<IProps> = ({
  intent,
  closeModal,
  inputJson,
  setInputJson,
  data
}) => {
  return (
    <div className='card h-600px w-400px'>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'>
          <span className='ms-1 badge bg-info fs-5'># {intent.id}</span>
        </span>
        <CloseButton onClick={closeModal} />
      </div>
      {!!intent.message.text && (
        <Text
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.message.attachment?.type && intent.message.attachment?.type === 'image' && (
        <Image
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.message.attachment?.type && intent.message.attachment?.type === 'audio' && (
        <Audio
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}

      {!!intent.message.attachment?.type && intent.message.attachment?.type === 'video' && (
        <Video
          intent={intent}
          inputJson={inputJson}
          setInputJson={setInputJson}
          closeModal={closeModal}
          data={data}
        />
      )}
    </div>
  )
}

export default CustomisationInstaModal
